import React from 'react'
import axios from 'axios'

import IngredientsActions from '~/actions/ingredients.js'

import DeleteWithConfirm from '~/modules/_core/deleteWithConfirm.jsx'

import apiUtils from '~/helper/api.js'


export default class RecipeIngredientsModalAddEdit extends React.Component {
	handleConfirm = () => {
		axios.patch(
			`${apiUtils.getApiURL()}/ingredients`,
			{
				ingredientID: this.props.ingredientID,
				isActive: 0
			}
		)
		.then(
			() => {
				// refresh the list
				IngredientsActions.reload()

				this.setState({ showModal: false })
			}
		)
	}

	render() {
		return (
			<DeleteWithConfirm
				message="Are you sure you want to delete this ingredient?"
				handleConfirm={this.handleConfirm}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes/delete.jsx